namespace advisorop.components.servicer {

    export class ServicerListController {

        public servicers;
        public dg; 
        public onServicerChanged: (any) => any;       
        public user: domains.identity.IUser;

        constructor(private servicerService: services.ServicerService,
            private identityService: services.IdentityService,
            generalService: services.GeneralService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Services"
                },
                bindingOptions: {
                    dataSource: "vm.servicers"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgServicerSettings"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },                
                columns: [
                    { dataField: 'firstName', caption: 'Name', width: 160, cellTemplate: 'colFullName', sortIndex: 0, sortOrder: "asc" },
                    //{ dataField: 'tin', caption: 'TIN/SSN', width: 140, visible: false },
                    { dataField: 'username', caption: 'Username', visible: true, width: 90 },       
                    { dataField: 'loginStatusDesc', caption: 'Status', visible: true, width: 80 },
                    // dataField and dataType stay so the column still sorts and filters on the
                    // underlying boolean; the template just replaces the checkbox with the control.
                    { dataField: 'twoFactorEnabled', caption: '2FA', visible: true, width: 85, dataType: 'boolean', cellTemplate: 'colTwoFactor' },
                    { dataField: 'ssoMode', caption: 'Login Option', visible: true, width: 155, cellTemplate: 'colSsoMode',
                      lookup: { dataSource: advisorop.identity.SsoModeOption.all(), valueExpr: 'value', displayExpr: 'label' } },
                    { dataField: 'systemLoginTypeDesc', caption: 'Role', visible: true, width: 100 },
                    {
                        caption: 'Last Login', visible: true, dataType: 'date', format: 'MM/dd/yy hh:mm a', width: 105,
                        allowSorting: true, allowFiltering: true,
                        calculateCellValue: function (servicer) {
                            if (!servicer.lastLogin) {
                                return "";
                            }
                            return new Date(generalService.toUTCDateString(servicer.lastLogin));
                        } },
                    { name: 'actions', dataField: 'username', caption: '#', cellTemplate: 'btnActions' },
                ]
                //selection: {
                //    mode: 'single',
                //    showCheckBoxesMode: 'onClick'
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onServicerChanged({ id: data.id });
                //    }
                //}
            };
        }


        // /////////////////////////////////////////////////////////
        // Servicer system login methods      
        enableSL(servicer: domains.identity.IUser): void {
            this.servicerService.enableServicerSL(servicer)
                .success((data) => {
                    angular.copy(data, servicer);                
                    toastr.success("Activation email sent to servicer at " + servicer.email + ".");
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });
        };

        reactivateSL(servicer: domains.identity.IUser): void {
            this.servicerService.reactivateServicerSL(servicer)
                .success((data) => {
                    angular.copy(data, servicer); 
                    toastr.success("Reactivation email sent to servicer at "+servicer.email+".");
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });
        };

        disableSL(servicer: domains.identity.IUser): void {
            this.servicerService.disableServicerSL(servicer)
                .success((data) => {
                    angular.copy(data, servicer); 
                    toastr.success("User system login canceled.");
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });            
        };

        lockSL(servicer: domains.identity.IUser): void {
            this.servicerService.lockServicerSL(servicer)
                .success((data) => {
                    angular.copy(data, servicer); 
                    toastr.success("User system login has been locked.");
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });            
        };

        unlockSL(servicer: domains.identity.IUser): void {
            this.servicerService.unlockServicerSL(servicer)
                .success((data) => {
                    servicer.loginStatus = 1;
                    servicer.loginStatusDesc = "ACTIVE";
                    toastr.success("User system login unlocked.");
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });            
        }

        // Only an administrator may switch two-factor authentication off; the server enforces
        // this in IdentityService.SetTwoFactorEnabled, this only keeps the action out of the UI.
        isAdmin(): boolean {
            return (this.user && this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
        }

        /// Only shown where the deployment actually has Salesforce sign-in. One build serves every
        /// client, so an ungated control would offer fifteen of them a sign-in method they do not
        /// have.
        ssoEnabled: boolean = false;
        ssoModes = advisorop.identity.SsoModeOption.all();

        ssoModeLabel(mode: number): string {
            return advisorop.identity.SsoModeOption.label(mode);
        }
        /// What the value was before the select was touched. ng-model has already changed the row
        /// by the time ng-change fires, so a cancelled confirmation or a failed save needs this to
        /// put it back rather than leave the screen claiming something the server never accepted.
        private ssoModeBefore: number = null;

        rememberSsoMode(servicer: domains.identity.IUser): void {
            this.ssoModeBefore = servicer.ssoMode || 0;
        }

        /// Changes how this login may authenticate. The server records who did it.
        setSsoMode(servicer: domains.identity.IUser): void {
            const mode = servicer.ssoMode;
            const previous = this.ssoModeBefore;

            if (mode === previous) {
                return;
            }

            if (!advisorop.identity.SsoModeOption.confirm(mode, servicer.fullName)) {
                servicer.ssoMode = previous;
                return;
            }

            this.servicerService.setSsoModeServicerSL(servicer, mode)
                .success((data) => {
                    angular.copy(data, servicer);
                    toastr.success(advisorop.identity.SsoModeOption.message(mode, servicer.fullName));
                })
                .error((data, status) => {
                    servicer.ssoMode = previous;
                    toastr.error("Error " + status + " " + data);
                });
        };

        setTwoFactor(servicer: domains.identity.IUser, enabled: boolean): void {
            // Off is always for a stated number of days; the enforcement job switches it back on
            // when they run out, so the administrator is told the date rather than left to
            // remember. See advisorop.identity.TwoFactorExemption for the wording and the range.
            let days: number = null;
            if (!enabled) {
                days = advisorop.identity.TwoFactorExemption.promptForDays(servicer.fullName);
                if (days === null)
                    return;
            }

            this.servicerService.setTwoFactorServicerSL(servicer, enabled, days)
                .success((data) => {
                    angular.copy(data, servicer);
                    toastr.success(enabled
                        ? "Two-factor authentication turned on."
                        : advisorop.identity.TwoFactorExemption.offMessage(servicer.fullName, days));
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });
        };

        getServicers(): void {
            this.servicerService.getServicers()
                .success((data) => {
                    this.servicers = data;
                })
                .error((data, status) => {
                    toastr.error("SERVICERS ERROR " + status + " " + data);
                });
        }

        $onInit(): void {
            this.identityService.getSsoConfig().then((response: any) => {
                this.ssoEnabled = !!(response.data && response.data.enabled);
            }, () => { this.ssoEnabled = false; });

            this.identityService.getUserPromise().then(response => {
                this.user = response;
            });
            this.getServicers();
        }
        
    }
    
    class ServicerList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = ["servicerService", "identityService", "generalService", ServicerListController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/servicer-list.html';
        }
    }
    angular.module(Constants.APP).component("servicerList", new ServicerList());

}